module.exports = __webpack_public_path__ + "static/media/wallet-buy-airtime.640da76b.png";